<template>
  <div class="AnnualIncomeField">
    <div class="label"><span class="required">*</span>{{ label }}</div>
    <div class="value">
      <input
        v-model="AnnualIncomeField"
        type="number"
        placeholder="输入您的年收入"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "AnnualIncomeField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      AnnualIncomeField: "",
    };
  },
  async mounted() {},
  methods: {
    handleInput(val) {
      this.AnnualIncomeField = val.target.value;
      this.$emit("input", val.target.value);
    },
  },
  watch: {
    value(newVal) {
      this.AnnualIncomeField = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.AnnualIncomeField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 80px;
  .required {
    color: #ff0000;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 33px;
  border-radius: 17px;
  background: #F8F8F8;
  padding-left: 16px;
  font-size: 14px;
  input {
    border: none;
    outline: none;
    background: transparent;
    &::placeholder {
      color: rgba(51,51,51,0.4);
    }
  }
}
</style>
